'use client';
import { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import ReactQuill, { Quill } from "react-quill";
import 'react-quill/dist/quill.snow.css';
import ImageResize from "quill-image-resize-module-react";
import { CMM } from 'Lib/Cmm';
import { fetchAxios, postWithFile } from 'Lib/GetAxios';

import 'react-quill/dist/quill.snow.css'; // Import Quill styles

Quill.register("modules/imageResize", ImageResize);


const QuillEditor = (props) => {

  const quillRef = useRef(null);


  useEffect(() => {
    if (quillRef.current) {
      const editor = quillRef.current.getEditor();
      editor.root.style.height = '500px'; // 원하는 높이로 설정
    }
  }, []);

  const imageHandler = () => {
    const input = document.createElement('input');

    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    document.body.appendChild(input);

    input.click();

    input.onchange = async () => {
      const [file] = input.files;

      try {
        const resUrl = await postWithFile(`${CMM.SERVER_URL_API}/admin/noti_editor_files`, {}, [{ uri: file, name: file.name }]);

        const editor = quillRef.current.getEditor();
        const range = editor.getSelection();
        editor.insertEmbed(range.index, 'image', `${CMM.SERVER_URL_API}/files/${resUrl}`);
        editor.setSelection(range.index + 1);

      } catch (e) {
        console.log('imagehandel error::', e);
      }

    };
  }

  const modules = useMemo(() => ({
    toolbar: {
      container: [
        [{ 'header': [1, 2, false] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
        ['link', 'image'],
        [{ size: [] }],
        [{ align: [] }],
        [{ color: [] }],
        ['clean']
      ],
      handlers: { image: imageHandler }

    },
    imageResize: {
      parchment: Quill.import("parchment"),
      modules: ["Resize", "DisplaySize"],
    },
  }), []);

  const quillFormats = [
    'header',
    'font',
    'size',
    'bold',
    'italic',
    'underline',
    'strike',
    'align',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'background',
    'color',
    'link',
    'image',
    'video',
    'width',
    'code-block',
  ];

  return (
    <>
      <ReactQuill
        ref={quillRef}
        value={props.value}
        onChange={props.onChange}
        //modules={quillModules}
        modules={modules}
        formats={quillFormats}
        className={`${(props.className) ? props.className : 'w-full my-3 bg-white'}`}
      />
      <script src="/node_modules/quill-image-resize-module/image-resize.min.js"></script>
    </>

  )
}

export default QuillEditor
